import React from "react";

import { Grid } from "@mui/material";

import { ESupplyChainOverviewTabs, ShipmentsConfigure } from "../../../../../models/supply.chain.overview.configure";
import { useSupplyChainOverviewContext } from "../../context";
import ConfigWidget from "../ConfigWidget";

const ShipmentsConfig = () => {
  const { config, dashboard, handleWidgetConfigChange } = useSupplyChainOverviewContext();

  const configs: Array<keyof ShipmentsConfigure> = [
    "shipmentsTracked",
    "shipmentsPerDate",
    "shipmentStatuses",
  ];

  return (
    <Grid container spacing={0}>
      {configs.map((label: keyof ShipmentsConfigure) => (
        <Grid item key={`shipmentsConfig-${label}`} xs={4}>
          <ConfigWidget
            handleChange={(value) => handleWidgetConfigChange(ESupplyChainOverviewTabs.SHIPMENTS, label, value)}
            label={label}
            type={dashboard.shipments?.graphs[label].type}
            value={config.shipments[label] as boolean}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default ShipmentsConfig;
